<template>
  <div class="pc-footer">
    <div class="logo-wrap">
      <img src="@/assets/images/pc/moonton.png" class="logo" alt="">
      <img src="@/assets/images/pc/logo2.png" class="logo" alt="">
    </div>
    <div class="social-box">
      <a :href="i.link" target="_blank" class="icon" v-for="(i, index) in list" :key="index">
        <img :src="i.icon" alt="">
      </a>
      <div>
        <a href="https://www.mobilelegends.com/en/info/2?policy=1" target="_blank" class="policy p1">{{$t('message.strid9')}}</a>
        <a href="https://www.mobilelegends.com/en/info/3?policy=1" target="_blank" class="policy p2">{{$t('message.strid10')}}</a>
      </div>
      <p class="right">{{$t('message.strid11')}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["_myData"]),
  },
  watch: {
    '_myData': {
      handler (n, o) {
        if (n) {
          const data = n.bottom
          data.platform[this.$i18n.locale].map(i => {
            this.list.push({
              icon: i.img,
              link: i.url
            })
          })
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      list: []
    }
  }
};
</script>

<style lang="scss">
.pc-footer {
  width: 100%;
  height: 261px;
  background: #010d35;
  position: relative;

  .logo-wrap{
    width: 325px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transform: translateX(-222px);

    .logo {
      width: 142px;
    }
  }

  .social-box{
    width: 400px;
    margin-left: 121px;
    height: 100px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    transform: translateX(236px);

    .icon{
      width: 32px;
      height: 32px;
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .policy{
      color: #fff;
      opacity: 0.8;
      font-size: 16px;
      padding-right: 16px;
      display: inline-block;
      margin-top: 24px;

      &.p1{
        border-right: 1px solid rgba(255, 255, 255, 0.8);
      }

      &.p2 {
        margin-left: 16px;
      }
    }

    .right{
      color: #fff;
      opacity: 0.8;
      font-size: 16px;
      margin-top: 10px;
    }
  }
}
</style>